import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import Upload from '@common/Upload'
import 'antd4/lib/grid/style/index.css'
import { Button, Col, Input, Modal, Popconfirm, Radio, Row } from 'hljd'
import React, { Component } from 'react'
import style from './index.module.less'

const FormItem = Form.Item

@Form.create()
export default class extends Component {
  static defaultProps = {
    formValue: {}
  }
  save = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.id = this.props.formValue.id || ''
        this.props.onOk(values)
      }
    })
  }

  del = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.id = this.props.formValue.id || ''
        values.deleted = 1
        this.props.onOk(values)
      }
    })
  }

  onOkCoverImg = (file, link) => {
    const { form } = this.props

    form.setFieldsValue({
      cover_path: link
    })
  }

  onDeleteCoverImg = e => {
    const { form, formValue } = this.props
    form.setFieldsValue({
      cover_path: ''
    })

    formValue.coverPath = ''
  }

  onClipedCoverImg = ({ clipUrl }) => {
    const { form } = this.props
    form.setFieldsValue({
      cover_path: clipUrl
    })
  }

  render() {
    const { onClose, visible, form, formValue = {} } = this.props
    const { getFieldDecorator, getFieldValue } = form
    const cover_path = getFieldValue('cover_path') || formValue.coverPath
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
    return (
      <Modal
        title={formValue.id ? '编辑分类' : '新建分类'}
        visible={visible}
        onOk={this.save}
        onCancel={onClose}
        width={600}
        footer={null}
        destroyOnClose={true}
      >
        <Form>
          <Row className={style.wrapper}>
            <Col span={12}>
              <FormItem label="分类名称" {...formItemLayout}>
                {getFieldDecorator('title', {
                  initialValue: formValue.title || '',
                  rules: [
                    { required: true, message: '分类名称必填' }
                    // { max: 5, message: '请输入长度不超过5个字的分类名称' }
                  ]
                })(<Input placeholder="分类名称最多五个字" maxLength={5} />)}
              </FormItem>
              <FormItem label="是否展示" {...formItemLayout}>
                {getFieldDecorator('is_show', {
                  initialValue:
                    formValue.isShow != undefined ? formValue.isShow + '' : '1',
                  rules: [{ required: true }]
                })(
                  <Radio.Group>
                    <Radio value="1">是</Radio>
                    <Radio value="0">否</Radio>
                  </Radio.Group>
                )}
              </FormItem>
              <FormItem label="封面" {...formItemLayout}>
                {getFieldDecorator('cover_path', {
                  initialValue: formValue.coverPath || '',
                  rules: []
                })(
                  <Upload
                    // eslint-disable-next-line no-undef
                    javaUpTokenUrl={`${__JAVA__DOMAIN__}/hms/mediacenter/appApi/media/app/token?from=MerchantImage`}
                    width={100}
                    height={100}
                    aspect={10 / 10}
                    link={cover_path}
                    onOk={this.onOkCoverImg}
                    onDelete={this.onDeleteCoverImg}
                    autoSizeError={true}
                    clipabled
                    noUploadMark={true}
                    max_file_size="15mb"
                    onCliped={this.onClipedCoverImg}
                    filters={{
                      mime_types: [
                        {
                          title: 'images files',
                          extensions: 'jpg,gif,png,jpeg,bmp'
                        }
                      ],
                      prevent_duplicates: true
                    }}
                    description={
                      <div className={style.uploadWrap}>
                        <div className={style.upIcon}>+</div>
                        <div className={style.upTip}>上传图片</div>
                      </div>
                    }
                  />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <img
                className={style.imgStyle}
                src="https://qnm.hunliji.com/o_1cjd4ksmofs0qdguq41vnc1f26c.jpg"
              />
              <p className={style.imgTip}>APP内展示</p>
              <img
                className={style.imgStyle}
                src="https://qnm.hunliji.com/o_1cjd4hf0i9hqjebcj0n231bgf7.jpg"
              />
              <p className={style.imgTip}>水镜内展示</p>
            </Col>
          </Row>
        </Form>
        <div
          style={{
            display: 'flex',
            padding: '10px 16px 0',
            borderTop: '1px solid #e8e8e8',
            marginTop: '10px'
          }}
        >
          {formValue.id && (
            <Popconfirm
              title="删除后，该分类下的案例将移至「未分类」下"
              onConfirm={this.del}
            >
              <Button type="default">删除</Button>
            </Popconfirm>
          )}
          <Button
            type="default"
            style={{ marginLeft: 'auto', marginRight: '10px' }}
            onClick={onClose}
          >
            取消
          </Button>
          <Button type="primary" onClick={this.save}>
            确定
          </Button>
        </div>
      </Modal>
    )
  }
}
